import { render, staticRenderFns } from "./StaffEntrySearchBarComponent.vue?vue&type=template&id=037fd345"
import script from "./StaffEntrySearchBarComponent.vue?vue&type=script&lang=js"
export * from "./StaffEntrySearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./StaffEntrySearchBarComponent.vue?vue&type=style&index=0&id=037fd345&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports